<div class="main-content-auth">
    <app-auth-header></app-auth-header>
    <router-outlet></router-outlet>
    <app-auth-footer></app-auth-footer>
</div>